<template>
  <div>
    <Row>
      <Col span="5">
        <Input search v-model="subjectToBeProcessedSearchKey" :placeholder="$t('configuration_management.mailbox_management.queryByKeyWord')" @on-search="searchSchedule()"/>
      </Col>
    </Row>
  </div>
</template>
<script>

  import TableSubjectToBeProcessed from "./TableSubjectToBeProcessed";

  var tableSubjectToBeProcessed = TableSubjectToBeProcessed;
  export default {
    name: 'subjectToBeProcessedSearch',
    components: {
    },
    data() {
      return {
        subjectToBeProcessedSearchKey: '',
        subjectToBeProcessedSearchName: ''
      }
    },
    methods: {
      searchSchedule() {
        eventBus.$emit('subjectToBeProcessedSearchName', this.subjectToBeProcessedSearchKey);
        tableSubjectToBeProcessed.methods.showAll();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/SubjectToBeProcessedSearch.vue